module.exports = __webpack_public_path__ + "media/images/theme/icons/star_on-7889004080ac621b196a395a601492ad.svg";